import { defineMessages } from 'react-intl';

/** Copy for the "Default landing page" Display Controls row (MUL-3717). */
export const defaultLandingPageMessages = defineMessages({
  label: {
    defaultMessage: 'Default page',
    id: 'mCxQGetLo4',
    description: 'Display controls row label: which page Heidi opens on after login',
  },
  description: {
    defaultMessage: 'Choose where Heidi opens after you log in',
    id: '/aly2ZsAi1',
    description: 'Explanation under the Default landing page row',
  },
  optionHome: {
    defaultMessage: 'Home',
    id: '6iKNvYDivq',
    description: 'Default landing page option: the Heidi II Home page',
  },
  optionScribe: {
    defaultMessage: 'Scribe',
    id: 'ol4Bfk09wR',
    description: 'Default landing page option: the Scribe session list',
  },
  // Same wording and id as the other settings forms' success toast.
  savedToast: {
    defaultMessage: 'Your settings have been updated',
    id: 'IjOfwTtVxG',
  },
  saveFailedToast: {
    defaultMessage: 'Something went wrong',
    id: 'JqiqNj0Ooi',
  },
});
